
import { EnvironmentProviders, ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { NavigationService } from "./navigation/services/navigation.service";
import { VerticalNavigationStrategyService } from "./navigation/services/vertical-navigation-strategy.service";
import { HorizontalNavigationStrategy } from "./navigation/services/horizontal-navigation-strategy.service";
import { LeftRightChangeSectionUpDownChangeFieldNavigationStrategy } from "./navigation/services/left-right-change-section-up-down-change-field-navigation-strategy.service";
import { UpDownChangeSectionLeftRightChangeFieldNavigationStrategy } from "./navigation/services/up-down-change-section-left-right-change-field-navigation-strategy.service";
import { LeftRightToolbarUpDownFieldsNavigationStrategy } from "./navigation/services/left-right-toolbar-up-down-fields-navigation-strategy.service";

export const HANDLING_TOOL_SLUG = 'handlingtool';
export const HANDLING_TOOL_SLUG_FULL_PATH = `/manage/${HANDLING_TOOL_SLUG}`;

export const HANDLING_PLATFORM_TYPE_SLUG = 'handlingplatformtype';
export const HANDLING_PLATFORM_TYPE_SLUG_FULL_PATH = `/manage/${HANDLING_PLATFORM_TYPE_SLUG}`;

export const LOGISTIC_TASK_LAUNCHER_TYPE_SELECTION_SLUG = 'logistictasklaunchertypeselection';
export const LOGISTIC_TASK_LAUNCHER_TYPE_SELECTION_SLUG_FULL_PATH = `/manage/${LOGISTIC_TASK_LAUNCHER_TYPE_SELECTION_SLUG}`;

export const LOGISTIC_TASK_LAUNCHER_SEARCH_SLUG = 'logistictasklaunchersearch';
export const LOGISTIC_TASK_LAUNCHER_SEARCH_SLUG_FULL_PATH = `/manage/${LOGISTIC_TASK_LAUNCHER_SEARCH_SLUG}`;

export const LOGISTIC_TASK_LAUNCHER_SIMPLIFIED_SLUG = 'logistictasklaunchersimplified';
export const LOGISTIC_TASK_LAUNCHER_SIMPLIFIED_SLUG_FULL_PATH = `/manage/${LOGISTIC_TASK_LAUNCHER_SIMPLIFIED_SLUG}`;

export const LOGISTIC_TASK_LAUNCHER_MANUAL_SLUG = 'logistictasklaunchermanual';
export const LOGISTIC_TASK_LAUNCHER_MANUAL_SLUG_FULL_PATH = `/manage/${LOGISTIC_TASK_LAUNCHER_MANUAL_SLUG}`;

export const LOGISTIC_MOVEMENT_TASK_LAUNCHER_MANUAL_SLUG = 'logisticmovementtasklaunchermanuallongop';
export const LOGISTIC_MOVEMENT_TASK_LAUNCHER_MANUAL_SLUG_FULL_PATH = `/manage/${LOGISTIC_MOVEMENT_TASK_LAUNCHER_MANUAL_SLUG}`;

export const LOGISTIC_LOWERING_TASK_LAUNCHER_MANUAL_SLUG = 'logisticloweringtasklaunchermanuallongop';
export const LOGISTIC_LOWERING_TASK_LAUNCHER_MANUAL_SLUG_FULL_PATH = `/manage/${LOGISTIC_LOWERING_TASK_LAUNCHER_MANUAL_SLUG}`;

export const LOGISTIC_TASK_CONSOLE_SEARCH_SLUG = 'logistictaskconsolesearch';
export const LOGISTIC_TASK_CONSOLE_SEARCH_SLUG_FULL_PATH = `/manage/${LOGISTIC_TASK_CONSOLE_SEARCH_SLUG}`;

export const LOGISTIC_INTERNAL_TASK_LAUNCHER_SEARCH_SLUG = 'logisticinternaltasklaunchersearchlongop';
export const LOGISTIC_INTERNAL_TASK_LAUNCHER_SEARCH_SLUG_FULL_PATH = `/manage/${LOGISTIC_INTERNAL_TASK_LAUNCHER_SEARCH_SLUG}`;

export const LOGISTIC_LOWERING_TASK_LAUNCHER_SEARCH_SLUG = 'logisticloweringtasklaunchersearchlongop';
export const LOGISTIC_LOWERING_TASK_LAUNCHER_SEARCH_SLUG_FULL_PATH = `/manage/${LOGISTIC_LOWERING_TASK_LAUNCHER_SEARCH_SLUG}`;

export const LOGISTIC_MOVEMENT_TASK_LAUNCHER_SIMPLIFIED_SLUG = 'logisticmovementtasklaunchersimplifiedlongop';
export const LOGISTIC_MOVEMENT_TASK_LAUNCHER_SIMPLIFIED_SLUG_FULL_PATH = `/manage/${LOGISTIC_MOVEMENT_TASK_LAUNCHER_SIMPLIFIED_SLUG}`;

export const LOGISTIC_LOWERING_TASK_LAUNCHER_SIMPLIFIED_SLUG = 'logisticloweringtasklaunchersimplifiedlongop';
export const LOGISTIC_LOWERING_TASK_LAUNCHER_SIMPLIFIED_SLUG_FULL_PATH = `/manage/${LOGISTIC_LOWERING_TASK_LAUNCHER_SIMPLIFIED_SLUG}`;

export const LOGISTIC_INVENTORY_TASK_LAUNCHER_SEARCH_SLUG = 'logisticinventorytasklaunchersearchlongop';
export const LOGISTIC_INVENTORY_TASK_LAUNCHER_SEARCH_SLUG_FULL_PATH = `/manage/${LOGISTIC_INVENTORY_TASK_LAUNCHER_SEARCH_SLUG}`;

export const LOGISTIC_INVENTORY_TASK_LAUNCHER_SIMPLIFIED_SLUG = 'logisticinventorytasklaunchersimplifiedlongop';
export const LOGISTIC_INVENTORY_TASK_LAUNCHER_SIMPLIFIED_SLUG_FULL_PATH = `/manage/${LOGISTIC_INVENTORY_TASK_LAUNCHER_SIMPLIFIED_SLUG}`;

export const LOGISTIC_INVENTORY_TASK_LAUNCHER_MANUAL_SLUG = 'logisticinventorytasklaunchermanuallongop';
export const LOGISTIC_INVENTORY_TASK_LAUNCHER_MANUAL_SLUG_FULL_PATH = `/manage/${LOGISTIC_INVENTORY_TASK_LAUNCHER_MANUAL_SLUG}`;

export const HAND_HELD_MENU_SLUG = 'handheldmenu';
export const HAND_HELD_MENU_SLUG_FULL_PATH = `/manage/${HAND_HELD_MENU_SLUG}`;
export const HAND_HELD_MENU_FULL_NAME = 'Logistic.HandHeldMenuObjects.Models.HandHeldMenu';

export const HAND_HELD_STOCK_ITEMS_FULL_NAME = 'Logistic.HandHeldStockItemsLongOpObjects.Models.HandHeldStockItemsLongOp';

export const REPORT_PATH_MOVEMENT_UNIT = '/MovementUnitReport/';
export const REPORT_PATH_HANDLING_UNIT = '/HandlingUnitReport/';
export const REPORT_PATH_HANDLING_PLATFORM = '/HandlingPlatformReport/';

export const SPOOL_TEMPLATE_FULL_NAME = 'SpoolService.OperationObjects.Models.Operation';

export const SUBJECT_SUPPLIER_FULL_NAME = 'Subject.SupplierObjects.Models.Supplier';
export const SUBJECT_CUSTOMER_FULL_NAME = 'Subject.CustomerObjects.Models.Customer';

export const DELIVERY_PLAN_DETAIL_SLUG = 'deliveryplandetail';
export const DELIVERY_PLAN_DETAIL_SLUG_FULL_PATH = `/manage/${DELIVERY_PLAN_DETAIL_SLUG}`;
export const DELIVERY_PLAN_DETAIL_TEMPLATE_FULL_NAME = 'Logistic.DeliveryPlanDetailObjects.Models.DeliveryPlanDetail';
export const DELIVERY_PLAN_SEARCH_TEMPLATE_FULL_NAME = 'Logistic.DeliveryPlanSearchObjects.Models.DeliveryPlanSearch';
export const DELIVERY_PLAN_ADD_TASKS_TEMPLATE_FULL_NAME = 'Logistic.DeliveryPlanAddTasksObjects.Models.DeliveryPlanAddTasks';

export const LOGISTIC_TASK_CLASSIFICATION_FULL_NAME = 'Logistic.LogisticTaskClassificationObjects.Models.LogisticTaskClassification';
export const WORKFLOW_INBOUND_FULL_NAME = 'Logistic.WorkflowInboundObjects.Models.WorkflowInbound';
export const WORKFLOW_PICKING_FULL_NAME = 'Logistic.WorkflowPickingObjects.Models.WorkflowPicking';
export const WORKFLOW_LOWERING_FULL_NAME = 'Logistic.WorkflowLoweringObjects.Models.WorkflowLowering';
export const WORKFLOW_HANDLING_FULL_NAME = 'Logistic.WorkflowHandlingObjects.Models.WorkflowHandling';
export const WORKFLOW_INVENTORY_FULL_NAME = 'Logistic.WorkflowInventoryObjects.Models.WorkflowInventory';

@NgModule({
    imports: [

    ],
    declarations: [


    ],
    exports: [

    ],
    providers: [
    ]
})
export class SharedModule {

    static getRootProviders(): Array<Provider | EnvironmentProviders> {
        return [
            VerticalNavigationStrategyService,
            HorizontalNavigationStrategy,
            LeftRightChangeSectionUpDownChangeFieldNavigationStrategy,
            UpDownChangeSectionLeftRightChangeFieldNavigationStrategy,
            LeftRightToolbarUpDownFieldsNavigationStrategy,
            NavigationService,
        ];
    }

    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
        };
    }

    static forChild(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
